import { Card, Grid, Typography } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import { getPercentageText } from '../../Utils/TalentUtils';

interface KaziPieChartProps {
  chartKey: string;
  title: string;
  countTitle?: string;
  dataset: { label: string; value: number }[];
  height?: number;
  showPercentages?: boolean;
  onItemClick?: (item: { label: string; value: number }) => void;
}

export const KaziPieChart = ({
  chartKey,
  title,
  countTitle,
  dataset,
  height = 300,
  showPercentages = true,
  onItemClick,
}: KaziPieChartProps) => {
  const total = dataset.reduce((sum, item) => sum + item.value, 0);

  // Append values to labels
  const labeledDataset = dataset.map(item => {
    const percentageText = showPercentages
      ? getPercentageText(item.value, total)
      : '';

    const label = showPercentages
      ? `${item.label}  (${item.value}, ${percentageText})`
      : `${item.label}  (${item.value})`;

    return {
      ...item,
      label: label,
    };
  });

  return (
    <Card
      sx={{
        borderRadius: '12px',
        padding: '24px',
        margin: '24px',
      }}
    >
      <Grid key={chartKey} width={'100%'}>
        <Typography variant="lora-headline-small">{title}</Typography>
        <PieChart
          series={[
            {
              arcLabel: item =>
                showPercentages
                  ? `${getPercentageText(item.value, total)}`
                  : '',
              arcLabelMinAngle: 20,
              arcLabelRadius: '85%',
              data: labeledDataset,
              highlightScope: { fade: 'global', highlight: 'item' },
              faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
              valueFormatter: item => `${item.value} ${countTitle}`,
            },
          ]}
          height={height}
          onItemClick={(_, params) => {
            const clickedItem = dataset[params.dataIndex];
            onItemClick?.(clickedItem); // Pass clicked data back to parent
          }}
        />
      </Grid>
    </Card>
  );
};
